export default __webpack_public_path__ + "static/media/banner.67eab504.png";